import Page from "components/Page";
import PageBody from "components/PageBody";
import FarmHomePageHead from "containers/FarmHome/FarmHomePageHead";
import { compose, withAppContext } from "containers/HOC";
import NationalReporting from "containers/Admin/NationalReporting/NationalReporting";

const Benchmarks = ({ farm, authContext, refData }) => {
    const referrer = `/app/farm/${farm.id}`;

    const breadcrumb = [{ name: farm.displayName, to: referrer }, { name: "Benchmarks" }];

    return (
        <Page>
            <FarmHomePageHead farm={farm} authContext={authContext} refData={refData} breadcrumb={breadcrumb} />
            <PageBody>
                <NationalReporting farm={farm} isBenchmarksOnly={true} />
            </PageBody>
        </Page>
    );
};

export default compose(withAppContext)(Benchmarks);
